import React, { useEffect, useState } from 'react';
import './Header.scss';
import logo from '../images/mainlogomini.png';

interface MenuItem {
  title: string;
  url: string;
}

const MENUS: MenuItem[] = [
  { title: '회사소개', url: '/about' },
  { title: '포트폴리오', url: '/projects' },
  { title: '온라인계약', url: '/contract' },
  { title: '문의하기', url: '/inquiry' },
];

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const navigateTo = (url: string) => {
    window.location.href = url;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (menuOpen) return;
      if (window.scrollY > 10 && window.scrollY < 100) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) return;

    const scrollY = window.scrollY;
    const prev = {
      bodyOverflow: document.body.style.overflow,
      bodyPosition: document.body.style.position,
      bodyTop: document.body.style.top,
      bodyLeft: document.body.style.left,
      bodyRight: document.body.style.right,
      bodyWidth: document.body.style.width,
      bodyOverscroll: document.body.style.overscrollBehavior,
      htmlOverflow: document.documentElement.style.overflow,
      htmlHeight: document.documentElement.style.height,
      htmlOverscroll: document.documentElement.style.overscrollBehavior,
    };

    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100%';
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overscrollBehavior = 'none';

    return () => {
      document.body.style.overflow = prev.bodyOverflow;
      document.body.style.position = prev.bodyPosition;
      document.body.style.top = prev.bodyTop;
      document.body.style.left = prev.bodyLeft;
      document.body.style.right = prev.bodyRight;
      document.body.style.width = prev.bodyWidth;
      document.body.style.overscrollBehavior = prev.bodyOverscroll;
      document.documentElement.style.overflow = prev.htmlOverflow;
      document.documentElement.style.height = prev.htmlHeight;
      document.documentElement.style.overscrollBehavior = prev.htmlOverscroll;
      window.scrollTo(0, scrollY);
    };
  }, [menuOpen]);

  return (
    <div className="header">
      <div className="header-top">
        <div className="inner">
          <div className="container header-top-container">
            <p className="header-top__text">Digital Product Studio · 예플랫</p>
            <div className="header-button_wrap">
              <button
                type="button"
                className="header-button"
                onClick={() => navigateTo('/inquiry')}
              >
                프로젝트 문의 →
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="header-content">
        <div className="inner">
          <div className="container header-content-container">
            <button
              type="button"
              className="header-logo"
              onClick={() => navigateTo('/')}
              aria-label="YEPLAT 홈"
            >
              <img src={logo} alt="YEPLAT 로고" className="header-logo__mark" />
            </button>

            <nav className="header-menu" aria-label="주요 메뉴">
              {MENUS.map((item) => (
                <button
                  key={item.title}
                  type="button"
                  className="menu-item"
                  onClick={() => navigateTo(item.url)}
                >
                  {item.title}
                </button>
              ))}
            </nav>

            <div className={`header-hamburger_menu ${menuOpen ? 'header-hamburger_menu--open' : ''}`}>
              <button
                type="button"
                className="header-hamburger_icon"
                onClick={toggleMenu}
                aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'}
              />
              <div className="header-mobile_menu">
                <div className="mobile_menu-inner">
                  <div className="mobile_menu-top">
                    <span className="mobile_menu-announce">아이디어를 제품으로, 비즈니스를 플랫폼으로.</span>
                  </div>

                  <div className="mobile_menu-list">
                    {MENUS.map((item) => (
                      <button
                        key={item.title}
                        type="button"
                        className="mobile_menu-link"
                        onClick={() => {
                          navigateTo(item.url);
                          toggleMenu();
                        }}
                      >
                        {item.title}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
